import React, { useState } from 'react'
import { CheckCircleIcon } from '@heroicons/react/24/outline'
import * as api from '../../api/account'
import { useAuth } from '../../context/AuthContext'

/**
 * „Odbierz darmowy dostęp” (config `DARMOWY_DOSTEP`, decyzja właściciela 2026-10-19): miesiąc Premium za darmo dla
 * firmy (odebrać może każda osoba w zespole) albo konta bez firmy, dopóki nie ma płatności online. Backend:
 * `POST /premium/odbierz` (`accounts/plany.odbierz_darmowy_dostep`); po sukcesie odświeżamy profil, więc kłódki
 * znikają od razu.
 */

/** „18 listopada” z daty ISO. */
export const dataPremium = (iso) => new Date(`${iso}T12:00:00`).toLocaleDateString('pl-PL', { day: 'numeric', month: 'long' })

export const useOdbierzPremium = () => {
  const { odswiezProfil } = useAuth()
  const [stan, setStan] = useState({ busy: false, blad: '', doDnia: null })
  const odbierz = async () => {
    setStan({ busy: true, blad: '', doDnia: null })
    const res = await api.odbierzDarmowyDostep()
    if (!res.ok) {
      setStan({ busy: false, blad: res.error, doDnia: null })
      return null
    }
    const doDnia = (res.data.company || res.data.plan_konta)?.proba_do || null
    setStan({ busy: false, blad: '', doDnia })
    await odswiezProfil?.()
    return doDnia
  }
  return { ...stan, odbierz }
}

const KLASY = {
  duzy: 'flex h-[52px] w-full items-center justify-center rounded-xl bg-blue-600 text-base font-semibold text-white '
    + 'shadow-[0_6px_16px_rgba(37,99,235,0.28)] hover:bg-blue-700 disabled:cursor-wait disabled:opacity-70',
  maly: 'rounded-lg bg-blue-600 px-3 py-1.5 text-sm font-semibold text-white hover:bg-blue-700 disabled:cursor-wait '
    + 'disabled:opacity-70',
}

/** Przycisk z komunikatem po odebraniu. `onGotowe(doDnia)` dostaje ostatni dzień Premium. */
const OdbierzPremium = ({ etykieta = 'Odbierz darmowy dostęp', rozmiar = 'maly', className = '', onGotowe }) => {
  const { busy, blad, doDnia, odbierz } = useOdbierzPremium()
  if (doDnia) {
    return (
      <p role="status" className={`m-0 inline-flex items-center gap-1.5 text-sm font-semibold text-emerald-700 ${className}`}>
        <CheckCircleIcon className="h-5 w-5 flex-shrink-0" aria-hidden="true" />Masz Premium do {dataPremium(doDnia)}
      </p>
    )
  }
  return (
    <div className={className}>
      <button type="button" disabled={busy} className={KLASY[rozmiar]}
              onClick={async () => { const d = await odbierz(); if (d) onGotowe?.(d) }}>
        {busy ? 'Chwileczkę…' : etykieta}
      </button>
      {blad && <p role="alert" className="m-0 mt-2 text-sm text-red-700">{blad}</p>}
    </div>
  )
}

export default OdbierzPremium
